var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10863_11299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40417 46.5459C3.40417 45.65 4.05001 44.9834 4.92501 44.9834H9.48751V20.7334C9.48751 18.0667 10.8833 16.6917 13.5292 16.6917H49.3833C52.0708 16.6917 53.4458 18.0667 53.4458 20.7334V44.9834H57.9875C58.8625 44.9834 59.5083 45.65 59.5083 46.5459C59.5083 47.4209 58.8625 48.0875 57.9875 48.0875H4.92501C4.05001 48.0875 3.40417 47.4209 3.40417 46.5459ZM11.0292 44.9834H51.8833V20.9834C51.8833 19.15 50.9667 18.2542 49.1333 18.2542H13.7792C11.9458 18.2542 11.0292 19.15 11.0292 20.9834V44.9834Z",
    fill: "url(#paint0_linear_10863_11299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40417 46.5459C3.40417 45.65 4.05001 44.9834 4.92501 44.9834H9.48751V20.7334C9.48751 18.0667 10.8833 16.6917 13.5292 16.6917H49.3833C52.0708 16.6917 53.4458 18.0667 53.4458 20.7334V44.9834H57.9875C58.8625 44.9834 59.5083 45.65 59.5083 46.5459C59.5083 47.4209 58.8625 48.0875 57.9875 48.0875H4.92501C4.05001 48.0875 3.40417 47.4209 3.40417 46.5459ZM11.0292 44.9834H51.8833V20.9834C51.8833 19.15 50.9667 18.2542 49.1333 18.2542H13.7792C11.9458 18.2542 11.0292 19.15 11.0292 20.9834V44.9834Z",
    fill: "white",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10863_11299",
    x1: 31.4667,
    y1: 6.40002,
    x2: 31.4667,
    y2: 57.0667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6560FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803FCE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10863_11299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyber);
export default __webpack_public_path__ + "static/media/Cyber.06298e34fd1b4a34073ab4c3adc58d96.svg";
export { ForwardRef as ReactComponent };